import React from "react";
import { classNames } from "../../helpers";

export default function TwLabel(props) {
  const { children, className = "", error = false } = props

  let helperTextClass = "text-gray-500"
  if (error) {
    helperTextClass = "text-red-600"
  }
  return (
    <h6 className={classNames("text-sm/6 font-medium", helperTextClass, className)}>
      {children}
    </h6>
  );
}
